import "./accordion.css";

import Accordion from "react-bootstrap/Accordion";
import { Badge } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import parse from "html-react-parser";
import { useEffect, useRef } from "react";

import useStore from "stores/Store";

function AccordionSimple({ setAccordionState, data }) {
  const navigate = useNavigate();
  const { setFaqRef } = useStore();
  const ref = useRef(null);

  useEffect(() => {
    setFaqRef(ref);
  }, []);

  const handleNavigation = (path) => {
    if (path.startsWith("http")) {
      window.open(path, "_blank");
    } else {
      navigate(path);
    }
  };

  return (
    <Accordion
      id="accordion-simple"
      defaultActiveKey={0}
      onSelect={setAccordionState}
      //   data-aos="fade-down"
      ref={ref}
    >
      {data.map((item, index) => (
        <Accordion.Item key={index} eventKey={index}>
          <Accordion.Header>
            <div className="d-inline-flex align-items-center">
              {
                item?.title && <h5 className="mb-0">{parse(item?.title)}</h5>
              }
            </div>
          </Accordion.Header>
          {
            item?.content && <Accordion.Body>{parse(item?.content)}</Accordion.Body>
          }
        </Accordion.Item>
      ))}
    </Accordion>
  );
}

export default AccordionSimple;
